import React, { PureComponent } from 'react';
import { Switch, Route } from 'react-router-dom';
import {
  ROUTE_SIGNUP,
  ROUTE_SIGNIN,
  ROUTE_CONFIRM_EMAIL,
  ROUTE_FORGOT_PASSWORD,
} from 'common/constants';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BaseApp from './BaseApp';
import { ConfirmEmail, ForgotPassword, Login, Register } from 'pages';

class AppWithAuth extends PureComponent {
  render() {
    return this.props.isLoggedIn ? (
      <BaseApp />
    ) : (
      <Switch>
        <Route exact path={ROUTE_SIGNUP} component={() => <Register />} />
        <Route exact path={ROUTE_CONFIRM_EMAIL} component={ConfirmEmail} />
        <Route exact path={ROUTE_FORGOT_PASSWORD} component={ForgotPassword} />
        <Route path={ROUTE_SIGNIN} component={() => <Login />} />
        <Route component={() => <Login />} />
      </Switch>
    );
  }
}

AppWithAuth.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

const mapState = ({ auth: { isLoggedIn } }) => ({ isLoggedIn });

export default connect(mapState)(AppWithAuth);



// WEBPACK FOOTER //
// ./src/pages/App/index.js